import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {limitOptionsSelect} from "../helps/optionsSelect"
import {asyncCreator} from "./sliceHelper"
import {objectApi, ObjectsFilterQuery} from "../api/objectApi"
import {WSObject} from "../types/WebSocketTypes"
import {ObjectResponse, ObjectsResponse} from "../models/response"

export type ObjectsFilter = {
    limit: number
    offset: number
    status?: "-1" | "0" | "1"
}

export type ObjectSideObjectSide = {
    limitDevices: number
    offsetDevices: number
    status?: "-1" | "0" | "1" | "2"
    tabKey: string
    searchDevices?: string
}

export type ObjectSideSecurityLogsFilter = {
    limitSecurityLogs: number
    offsetSecurityLogs: number
    tabKey: string
    idDevice?: number
    idUser?: number
    changeMode?: "MANUAL" | "SCHEDULE" | "DEVICE"
    dateFromSecurityLogs?: string | null | undefined
    dateToSecurityLogs?: string | null | undefined
    searchSecurityLogs?: string
}

type InitialStateType = {
    objects: null | ObjectsResponse
    object: null | ObjectResponse
    filter: ObjectsFilter & ObjectsFilterQuery
    sideFilter: ObjectSideObjectSide & ObjectSideSecurityLogsFilter
    ws: WSObject | null
}

const initialState: InitialStateType = {
    objects: null,
    object: null,
    filter: {
        limit: limitOptionsSelect[0].value,
        offset: 0,
    },
    sideFilter: {
        limitDevices: limitOptionsSelect[0].value,
        offsetDevices: 0,
        limitSecurityLogs: limitOptionsSelect[0].value,
        offsetSecurityLogs: 0,
        tabKey: "1",
    },
    ws: null,
}

export const objectReducer = createSlice({
    name: "objectReducer",
    initialState,
    reducers: {
        setObjects(state, {payload})
        {
            state.objects = payload
        },
        setObject(state, {payload})
        {
            state.object = payload
        },
        addObject(state, {payload})
        {
            if (state.objects)
            {
                state.objects = {
                    total: state.objects.total += 1,
                    data: [payload, ...state.objects.data],
                }
            }
        },
        editObject(state, {payload}: PayloadAction<ObjectResponse>)
        {
            let index = state.objects?.data.findIndex(i => i.id === payload.id)
            if (index !== undefined && state.objects) state.objects.data[index] = payload
            if (state.object) state.object = payload
        },
        setObjectsFilter(state, {payload})
        {
            state.filter = payload
        },
        setObjectSideFilter(state, {payload})
        {
            state.sideFilter = payload
        },
        setWSObject(state, {payload}: PayloadAction<WSObject | null>)
        {
            state.ws = payload
        },
    },
})

export const {setObjects, setObject, addObject, editObject, setObjectsFilter, setObjectSideFilter, setWSObject} = objectReducer.actions

export default objectReducer.reducer

export const getObjects = asyncCreator
("objectReducer/getObjects", objectApi.getObjects, setObjects)

export const getObject = asyncCreator
("objectReducer/getObject", objectApi.getObject, setObject)

export const createObject = asyncCreator
("objectReducer/createObject", objectApi.createObject, addObject)

export const changeObject = asyncCreator
("objectReducer/changeObject", objectApi.changeObject, editObject)

export const deleteObject = asyncCreator
("objectReducer/deleteObject", objectApi.deleteObject)

export const armingObject = asyncCreator
("objectReducer/armingObject", objectApi.armingObject, editObject)